export enum ApplicationsAndCrLineStatuses  {
    approved_and_not_valid_data = 'approved_and_not_valid_data',
    unknown = 'unknown',
    pending_submission = 'pending_submission',
    submitting = 'submitting',
    pending_approval = 'pending_approval',
    transmission_error = 'transmission_error',
    failed = 'failed',
    approved_and_received = 'approved_and_received',
    approved = 'approved',
    disbursed = 'disbursed',
    closed = 'closed',
    rejected = 'rejected',
    more_data_and_not_verified = 'more_data_and_not_verified',
    more_data_and_verified = 'more_data_and_verified',
    approved_and_not_verified = 'approved_and_not_verified',
    approved_and_need_sign = 'approved_and_need_sign',
    approved_and_payment_pending = 'approved_and_payment_pending',
    approved_and_checked = 'approved_and_checked',
    loan_already_exist = 'loan_already_exist',
    finished = 'finished',
    sign_with_kyc = 'sign_with_kyc',
    canceled1 = 'canceled1',
    canceled = 'canceled',
}